// Lightweight i18n. Phase 1: en + hi only. Keys cover all Phase-1 strings.
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const dictionaries = {
    en: {
        // brand
        "brand.name": "AutoBrix",
        "brand.full": "AutoBrix · Workshop OS",
        // nav
        "nav.dashboard": "Dashboard",
        "nav.settings": "Settings",
        "nav.users": "Users",
        "nav.branches": "Branches",
        "nav.audit": "Audit Log",
        "nav.jobs": "Jobs",
        "nav.scan": "Scan",
        "nav.time": "Time",
        "nav.me": "Me",
        // login
        "login.title": "Sign in to your workshop",
        "login.subtitle": "Job cards, inventory and invoicing in one place.",
        "login.email": "Work email",
        "login.password": "Password",
        "login.submit": "Sign in",
        "login.create": "Create a new workshop",
        "login.demo_hint": "Demo: owner@acme-auto.test / Passw0rd!demo",
        // register
        "register.title": "Create your workshop",
        "register.subtitle": "5 minutes. No credit card.",
        "register.workshop_name": "Workshop name",
        "register.owner_name": "Your name",
        "register.owner_email": "Work email",
        "register.owner_password": "Password",
        "register.branch_code": "First branch code",
        "register.branch_name": "First branch name",
        "register.branch_state": "State code (GST)",
        "register.currency": "Default currency",
        "register.locale": "Default language",
        "register.submit": "Create workshop",
        "register.have_account": "Already have an account?",
        // dashboard
        "dash.welcome": "Welcome back",
        "dash.todays_jobs": "Today's Jobs",
        "dash.appointments": "Appointments",
        "dash.low_stock": "Low Stock",
        "dash.revenue": "Revenue",
        "dash.placeholder": "Coming in Phase",
        "dash.empty": "—",
        // settings
        "settings.tab_tenant": "Tenant",
        "settings.tab_branches": "Branches",
        "settings.tab_security": "Security",
        "settings.save": "Save changes",
        "settings.saved": "Settings saved.",
        // users
        "users.invite": "Invite user",
        "users.role": "Role",
        "users.branch": "Branches",
        "users.deactivate": "Deactivate",
        "users.activate": "Activate",
        "users.empty": "No team members yet.",
        // common
        "common.cancel": "Cancel",
        "common.save": "Save",
        "common.create": "Create",
        "common.delete": "Delete",
        "common.edit": "Edit",
        "common.search": "Search",
        "common.signout": "Sign out",
        "common.density": "Density",
        "common.compact": "Compact",
        "common.comfortable": "Comfortable",
        "common.lang": "Language",
        "common.theme": "Theme",
        "common.dark": "Dark",
        "common.light": "Light",
        "common.system": "System",
    },
    hi: {
        "brand.name": "AutoBrix",
        "brand.full": "AutoBrix · वर्कशॉप OS",
        "nav.dashboard": "डैशबोर्ड",
        "nav.settings": "सेटिंग्स",
        "nav.users": "उपयोगकर्ता",
        "nav.branches": "शाखाएँ",
        "nav.audit": "ऑडिट लॉग",
        "nav.jobs": "जॉब्स",
        "nav.scan": "स्कैन",
        "nav.time": "समय",
        "nav.me": "मैं",
        "login.title": "अपने वर्कशॉप में साइन इन करें",
        "login.subtitle": "जॉब कार्ड, इन्वेंट्री और इनवॉइसिंग एक जगह।",
        "login.email": "कार्य ईमेल",
        "login.password": "पासवर्ड",
        "login.submit": "साइन इन",
        "login.create": "नया वर्कशॉप बनाएँ",
        "login.demo_hint": "डेमो: owner@acme-auto.test / Passw0rd!demo",
        "register.title": "अपना वर्कशॉप बनाएँ",
        "register.subtitle": "5 मिनट। बिना क्रेडिट कार्ड।",
        "register.workshop_name": "वर्कशॉप का नाम",
        "register.owner_name": "आपका नाम",
        "register.owner_email": "कार्य ईमेल",
        "register.owner_password": "पासवर्ड",
        "register.branch_code": "पहली शाखा का कोड",
        "register.branch_name": "पहली शाखा का नाम",
        "register.branch_state": "राज्य कोड (GST)",
        "register.currency": "डिफ़ॉल्ट मुद्रा",
        "register.locale": "डिफ़ॉल्ट भाषा",
        "register.submit": "वर्कशॉप बनाएँ",
        "register.have_account": "पहले से खाता है?",
        "dash.welcome": "वापसी पर स्वागत है",
        "dash.todays_jobs": "आज के जॉब्स",
        "dash.appointments": "अपॉइंटमेंट्स",
        "dash.low_stock": "कम स्टॉक",
        "dash.revenue": "राजस्व",
        "dash.placeholder": "Phase में आ रहा है",
        "dash.empty": "—",
        "settings.tab_tenant": "टेनेंट",
        "settings.tab_branches": "शाखाएँ",
        "settings.tab_security": "सुरक्षा",
        "settings.save": "बदलाव सहेजें",
        "settings.saved": "सेटिंग्स सहेजी गईं।",
        "users.invite": "उपयोगकर्ता आमंत्रित करें",
        "users.role": "भूमिका",
        "users.branch": "शाखाएँ",
        "users.deactivate": "निष्क्रिय करें",
        "users.activate": "सक्रिय करें",
        "users.empty": "अभी कोई टीम सदस्य नहीं।",
        "common.cancel": "रद्द करें",
        "common.save": "सहेजें",
        "common.create": "बनाएँ",
        "common.delete": "हटाएँ",
        "common.edit": "संपादित करें",
        "common.search": "खोजें",
        "common.signout": "साइन आउट",
        "common.density": "डेंसिटी",
        "common.compact": "कॉम्पैक्ट",
        "common.comfortable": "कम्फर्टेबल",
        "common.lang": "भाषा",
        "common.theme": "थीम",
        "common.dark": "डार्क",
        "common.light": "लाइट",
        "common.system": "सिस्टम",
    },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => localStorage.getItem("gms.lang") || "en");
    const setLang = useCallback((l) => {
        setLangState(l);
        localStorage.setItem("gms.lang", l);
        document.documentElement.lang = l;
    }, []);
    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);
    const t = useCallback(
        (key) => {
            const dict = dictionaries[lang] || dictionaries.en;
            return dict[key] || dictionaries.en[key] || key;
        },
        [lang]
    );
    const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useT = () => useContext(I18nContext);
export const SUPPORTED_LANGS = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिन्दी" },
];
